import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import CommentsFromLMSObject from "@/lib/ScormApi/Scorm2004/interfaces/CommentsFromLMSObjectInterface"

export default function CommentsFromLMSObject (api: ScormAPI2004): CommentsFromLMSObject {
  let _comment = ""
  let _location = ""
  let _timestamp = ""

  return {
    get comment () {
      return _comment
    },
    set comment (comment) {
      api.isNotInitialized() ? _comment = comment : api.throwSCORMError(404)
    },
    get location () {
      return _location
    },
    set location (location) {
      api.isNotInitialized() ? _location = location : api.throwSCORMError(404)
    },
    get timestamp () {
      return _timestamp
    },
    set timestamp (timestamp) {
      api.isNotInitialized() ? _timestamp = timestamp : api.throwSCORMError(404)
    },
    toJSON: new JsonFormatter().apply
  }
}
